<template>
    <div
        class="container-fluid catalogo-page"
        :class="{
            'con-acciones': cantidadFigurasSeleccionadas > 0,
            'con-ayuda-seleccion': ayudaSeleccionVisible && cantidadFigurasSeleccionadas === 0
        }"
    >
        <AyudaSeleccion
            v-if="cantidadFigurasSeleccionadas === 0"
            cookie-name="ayudaSeleccionCatalogoCerrada"
            texto="Selecciona las figuras que te interesan con el carrito y usa el botón de WhatsApp para enviarnos tu selección."
            @visible-change="ayudaSeleccionVisible = $event"
        />
        <div class="catalogo-header">
            <div class="catalogo-title">
                <h1 ref="tituloCatalogo">{{ titulo }}</h1>
            </div>
            
            <form @submit.prevent>
                <input
                    class="form-control busqueda"
                    type="search"
                    name="buscar"
                    id="buscar"
                    placeholder="Buscar por nombre, licencia o tipo"
                    aria-label="Buscar productos"
                    v-model="busqueda"
                    @input="cambiarBusqueda"
                >
                <button
                    v-if="busqueda"
                    class="btn btn-secondary limpiar-busqueda"
                    type="button"
                    @click="limpiarBusqueda"
                >
                    Limpiar
                </button>
                <div class="orden-exclusivos">
                    <select
                        class="form-select orden"
                        aria-label="ordenar"
                        name="ordenar"
                        id="ordenar"
                        v-model="orden"
                        @change="ordenar"
                    >
                        <option value="">Ordena por</option>
                        <option value="menorPrecio">Menor precio</option>
                        <option value="mayorPrecio">Mayor precio</option>
                        <option value="alfabetico">Orden ABC</option>
                        <option value="masNuevo">Más nuevo</option>
                    </select>
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="exclusivos"
                            v-model="mostrarExclusivos"
                            @change="cambiarFiltroExclusivos"
                        >
                        <label class="form-check-label" for="exclusivos">
                            Filtrar exclusivos
                        </label>
                    </div>
                </div>
            </form>
        </div>

        <p v-if="descripcion" class="catalogo-descripcion alert alert-warning" role="alert">{{ descripcion }}</p>

        <div v-if="mostrarAlertaDescuentos" class="alert alert-warning" role="alert">
            Algunas piezas llegan con detalles o maltrato en caja, es por eso que se les aplica un descuento, hay otras que tienen descuento por que se pusieron en liquidación,
            preguntar el estado de la caja antes de comprar.
        </div>
          
        <template v-if="datosPop">
            <template v-if="datosPop.length > 0">
                <div class="all-figures-pop">
                    <TarjetaPop v-for="pop in datosPaginados" :key="pop.llavePop"
                        :pop="pop" :existencia="existencia"
                        :seleccionado="!!figurasSeleccionadas[pop.llavePop]"
                        :mostrar-precio-detalle="mostrarPrecioDetalleEnTarjeta(pop)"
                        @seleccion-actualizada="actualizarSeleccion"
                        @solicitar-detalle="abrirModalDetalle"
                    ></TarjetaPop>
                </div>
                <nav aria-label="Page navigation example" class="mt-5">
                    <Paginacion
                        @pagina-actualizada="paginaActualizada"
                        :paginaActual="paginaActual"
                        :datosPop="datosPop"
                    ></Paginacion>
                </nav>
            </template>
            <div v-else class="sin-resultados">
                No encontramos productos con esa búsqueda.
            </div>
        </template>
        <div v-if="cantidadFigurasSeleccionadas > 0" class="acciones-seleccion">
            <button class="btn btn-success enviar-seleccion" type="button" @click="mandarWhatsApp">
                <span class="whatsapp-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                        <path d="M20.5 3.5A11.8 11.8 0 0 0 12.1 0C5.5 0 .2 5.3.2 11.8c0 2.1.6 4.1 1.6 5.9L0 24l6.5-1.7a11.8 11.8 0 0 0 5.6 1.4h.1c6.5 0 11.8-5.3 11.8-11.8 0-3.2-1.2-6.2-3.5-8.4ZM12.2 21.7h-.1a9.8 9.8 0 0 1-5-1.4l-.4-.2-3.9 1 1-3.8-.2-.4a9.8 9.8 0 0 1-1.5-5.1c0-5.4 4.4-9.8 9.9-9.8a9.8 9.8 0 0 1 7 2.9 9.8 9.8 0 0 1 2.9 7c0 5.4-4.4 9.8-9.7 9.8Zm5.4-7.3c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.5-.6c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6 0-.1-.7-1.7-1-2.3-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.1 1.1-1.1 2.7s1.2 3.1 1.3 3.3c.1.2 2.3 3.5 5.6 4.9.8.3 1.4.5 1.9.7.8.2 1.5.2 2.1.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4Z"></path>
                    </svg>
                </span>
                Enviar selección
            </button>
            <button class="btn limpiar-seleccion" type="button" @click="limpiarSeleccion">
                <span class="limpiar-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                        <path d="M3 6h18"></path>
                        <path d="M8 6V4h8v2"></path>
                        <path d="M6 6l1 16h10l1-16"></path>
                        <path d="M10 11v6"></path>
                        <path d="M14 11v6"></path>
                    </svg>
                </span>
                Limpiar selección
            </button>
            <div class="total-seleccion" aria-live="polite">
                <span>Total</span>
                <strong>${{ totalSeleccion }}</strong>
            </div>
        </div>
        <div v-if="detalleUnicoModalAbierto" class="detalle-modal-backdrop" @click.self="cerrarModalDetalleUnico">
            <div class="detalle-modal" role="dialog" aria-modal="true" aria-labelledby="detalle-unico-title">
                <div class="detalle-modal-header">
                    <h2 id="detalle-unico-title">Figura con detalle/daño en caja</h2>
                    <button type="button" class="btn-close" aria-label="Cerrar" @click="cerrarModalDetalleUnico"></button>
                </div>
                <div class="detalle-modal-body">
                    <p class="detalle-modal-texto">
                        Desafortunadamente de esta pieza ya solo nos queda una con detalle/daño en caja, la cual se ofrece a menor precio.
                    </p>
                    <div class="detalle-modal-subtexto">
                        <span>Precio</span>
                        <div class="detalle-modal-precios">
                            <del class="precio-original">${{ opcionDetalleUnico ? opcionDetalleUnico.precioOriginal : '' }}</del>
                            <strong class="precio-detalle">${{ opcionDetalleUnico ? opcionDetalleUnico.precio : '' }}</strong>
                        </div>
                    </div>
                    <p v-if="modeloSinFigurasBuenEstado(popDetallePendiente)" class="detalle-caja-aviso" role="note">
                        <span class="detalle-caja-aviso-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 8v5"></path>
                                <path d="M12 16h.01"></path>
                            </svg>
                        </span>
                        <span>No contamos con figuras de este modelo que tengan cajas completamente libres de detalles o daños.</span>
                    </p>
                    <p class="detalle-modal-whatsapp">
                        <span class="detalle-whatsapp-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24">
                                <path d="M20.5 3.5A11.8 11.8 0 0 0 12.1 0C5.5 0 .2 5.3.2 11.8c0 2.1.6 4.1 1.6 5.9L0 24l6.5-1.7a11.8 11.8 0 0 0 5.6 1.4h.1c6.5 0 11.8-5.3 11.8-11.8 0-3.2-1.2-6.2-3.5-8.4ZM12.2 21.7h-.1a9.8 9.8 0 0 1-5-1.4l-.4-.2-3.9 1 1-3.8-.2-.4a9.8 9.8 0 0 1-1.5-5.1c0-5.4 4.4-9.8 9.9-9.8a9.8 9.8 0 0 1 7 2.9 9.8 9.8 0 0 1 2.9 7c0 5.4-4.4 9.8-9.7 9.8Zm5.4-7.3c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.5-.6c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6 0-.1-.7-1.7-1-2.3-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.1 1.1-1.1 2.7s1.2 3.1 1.3 3.3c.1.2 2.3 3.5 5.6 4.9.8.3 1.4.5 1.9.7.8.2 1.5.2 2.1.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4Z"></path>
                            </svg>
                        </span>
                        Se pueden solicitar fotos por WhatsApp.
                    </p>
                    <div class="detalle-modal-acciones">
                        <button type="button" class="btn btn-outline-dark" @click="confirmarDetalleUnico">
                            Agregar
                        </button>
                        <button type="button" class="btn btn-dark" @click="cerrarModalDetalleUnico">
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="detalleModalAbierto" class="detalle-modal-backdrop" @click.self="cerrarModalDetalle">
            <div class="detalle-modal" role="dialog" aria-modal="true" aria-labelledby="detalle-modal-title">
                <div class="detalle-modal-header">
                    <h2 id="detalle-modal-title">Seleccionar opción</h2>
                    <button type="button" class="btn-close" aria-label="Cerrar" @click="cerrarModalDetalle"></button>
                </div>
                <div class="detalle-modal-body">
                    <p class="detalle-modal-nota detalle-modal-nota-destacada">
                        En algunas ocasiones llegan figuras con detalle/daño en caja, esas figuras las separamos y las ofrecemos a menor precio.
                    </p>
                    <form class="detalle-modal-opciones" @submit.prevent="confirmarDetalle">
                        <label
                            v-for="opcion in opcionesDetalleModal"
                            :key="opcion.id"
                            class="detalle-modal-opcion"
                            :for="'detalle-opcion-' + opcion.id"
                        >
                            <input
                                :id="'detalle-opcion-' + opcion.id"
                                class="detalle-radio"
                                type="radio"
                                name="detalle-opcion"
                                :value="opcion.id"
                                v-model="detalleSeleccionModal"
                            >
                            <span class="detalle-opcion-contenido">
                                <strong class="detalle-opcion-titulo">{{ opcion.titulo }}</strong>
                                <span v-if="opcion.descripcion" class="detalle-opcion-descripcion">
                                    {{ opcion.descripcion }}
                                </span>
                                <span class="detalle-modal-precios">
                                    <del v-if="opcion.precioOriginal && Number(opcion.precioOriginal) !== Number(opcion.precio)" class="precio-original">${{ opcion.precioOriginal }}</del>
                                    <strong class="precio-detalle">${{ opcion.precio }}</strong>
                                </span>
                            </span>
                        </label>
                        <p v-if="modeloSinFigurasBuenEstado(popDetallePendiente)" class="detalle-caja-aviso" role="note">
                            <span class="detalle-caja-aviso-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="M12 8v5"></path>
                                    <path d="M12 16h.01"></path>
                                </svg>
                            </span>
                            <span>No contamos con figuras de este modelo que tengan cajas completamente libres de detalles o daños.</span>
                        </p>
                        <p v-if="hayOpcionesDetalleModal" class="detalle-modal-whatsapp">
                            <span class="detalle-whatsapp-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24">
                                    <path d="M20.5 3.5A11.8 11.8 0 0 0 12.1 0C5.5 0 .2 5.3.2 11.8c0 2.1.6 4.1 1.6 5.9L0 24l6.5-1.7a11.8 11.8 0 0 0 5.6 1.4h.1c6.5 0 11.8-5.3 11.8-11.8 0-3.2-1.2-6.2-3.5-8.4ZM12.2 21.7h-.1a9.8 9.8 0 0 1-5-1.4l-.4-.2-3.9 1 1-3.8-.2-.4a9.8 9.8 0 0 1-1.5-5.1c0-5.4 4.4-9.8 9.9-9.8a9.8 9.8 0 0 1 7 2.9 9.8 9.8 0 0 1 2.9 7c0 5.4-4.4 9.8-9.7 9.8Zm5.4-7.3c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.5-.6c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6 0-.1-.7-1.7-1-2.3-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.1 1.1-1.1 2.7s1.2 3.1 1.3 3.3c.1.2 2.3 3.5 5.6 4.9.8.3 1.4.5 1.9.7.8.2 1.5.2 2.1.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4Z"></path>
                                </svg>
                            </span>
                            Se pueden solicitar fotos por WhatsApp.
                        </p>
                        <div class="detalle-modal-acciones">
                            <button type="button" class="btn btn-outline-dark" @click="cerrarModalDetalle">
                                Cancelar
                            </button>
                            <button type="submit" class="btn btn-dark" :disabled="!detalleSeleccionModal">
                                Seleccionar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getDatabase, ref, get } from "firebase/database";
import TarjetaPop from './shared/TarjetaPop.vue';
import Paginacion from './shared/Paginacion.vue'
import AyudaSeleccion from './shared/AyudaSeleccion.vue';
import moment from 'moment';
import { validacionDisponibilidad } from '@/utils/inventario';

export default {
    components: { TarjetaPop, Paginacion, AyudaSeleccion },
    props: {
        titulo: {
            type: String,
            default: "Catálogo Funko Pop",
        },
        descripcion: {
            type: String,
            default: "",
        },
        soloDescuentos: {
            type: Boolean,
            default: false,
        },
        mostrarAlertaDescuentos: {
            type: Boolean,
            default: false,
        },
        promocion: {
            type: String,
            default: "",
        },
    },
    //props: ['pops'],
    data(){
        return{
            datosPopOriginal: null,
            datosPop: null,
            elementosPorPagina: 20,
            paginaActual: 1,
            orden: "",
            busqueda: "",
            mostrarExclusivos: false,
            ayudaSeleccionVisible: false,
            existencia: 0,
            figurasSeleccionadas: {},
            detalleModalAbierto: false,
            detalleUnicoModalAbierto: false,
            popDetallePendiente: null,
            detalleSeleccionModal: null,
        }
    },
    async created(){

        this.mostrarExclusivos = this.queryExclusivosActiva();
        this.busqueda = this.obtenerBusquedaDesdeQuery();
        this.orden = this.obtenerOrdenDesdeHash();
        this.existencia = this.validacionCookieExistencias();
        this.datosPopOriginal = await this.obtenerDatos();
        this.datosPopOriginal = this.datosPopOriginal.filter( 
            pop => validacionDisponibilidad(pop)[0] > 0
        );
        this.aplicarFiltros();
    },
    methods: {
        ordenar(){
            this.actualizarHashOrden();
            this.aplicarFiltros();
    
        },
        cambiarBusqueda(){
            this.actualizarQueryBusqueda();
            this.aplicarFiltros();
        },
        aplicarFiltros(){
            const busqueda = this.normalizarTexto(this.busqueda);
            let pops = [...this.datosPopOriginal];

            if(busqueda !== ""){
                pops = pops.filter(pop => {
                    return pop.textoBusqueda.includes(busqueda);
                });
            }

            if(this.mostrarExclusivos){
                pops = pops.filter(pop => !this.esTipoRegular(pop.tipoPopNormalizado));
            }

            if(this.soloDescuentos){
                pops = pops.filter(pop => Number(pop.descuentoPrecioPublico) > 0);
            }

            if(this.promocion){
                pops = pops.filter(pop => this.popTienePromocion(pop));
            }

            this.datosPop = this.ordenarPops(pops);
            this.paginaActualizada(1);
        },
        limpiarBusqueda(){
            this.busqueda = "";
            this.cambiarBusqueda();
        },
        cambiarFiltroExclusivos(){
            this.actualizarQueryExclusivos();
            this.aplicarFiltros();
        },
        queryExclusivosActiva(){
            const exclusivos = this.$route.query.exclusivos;
            return ["1", "true", "si"].includes(this.normalizarTexto(exclusivos));
        },
        esTipoRegular(tipoPopNormalizado){
            const tipoComparable = tipoPopNormalizado
                .replace(/[()]/g, " ")
                .replace(/\s+/g, " ")
                .trim();

            return [
                "regular",
                "regular plus",
                "regular premium"
            ].includes(tipoComparable);
        },
        obtenerClavesPromocion(){
            return [this.promocion].filter(Boolean);
        },
        valorPromocionActivo(valor){
            if(Array.isArray(valor)){
                return valor.some(item => this.obtenerClavesPromocion().includes(this.normalizarTexto(item).replace(/\s+/g, "")));
            }

            if(valor && typeof valor === "object"){
                return this.obtenerClavesPromocion().some(clave => valor[clave] === true || valor[clave] === 1 || valor[clave] === "true");
            }

            if(typeof valor === "string"){
                return this.obtenerClavesPromocion().includes(this.normalizarTexto(valor).replace(/\s+/g, ""));
            }

            return valor === true || valor === 1;
        },
        popTienePromocion(pop){
            return this.obtenerClavesPromocion().some(clave => this.valorPromocionActivo(pop[clave]))
                || this.valorPromocionActivo(pop.promociones)
                || this.valorPromocionActivo(pop.promocion);
        },
        obtenerBusquedaDesdeQuery(){
            const busqueda = this.$route.query.buscar || this.$route.query.q || "";
            return Array.isArray(busqueda) ? busqueda[0] || "" : busqueda;
        },
        obtenerOrdenDesdeHash(){
            const filter = this.$route.params.filter;
            const hash = this.$route.hash || window.location.hash;
            const orden = filter || hash.replace("#", "");
            const ordenesValidas = ["menorPrecio", "mayorPrecio", "alfabetico", "masNuevo"];

            return ordenesValidas.includes(orden) ? orden : "masNuevo";
        },
        actualizarHashOrden(){
            if(this.soloDescuentos){
                this.$router.replace({
                    path: this.$route.path,
                    query: this.$route.query,
                    hash: this.orden ? `#${this.orden}` : "",
                });
                return;
            }

            const path = this.orden ? `/${this.orden}` : "/";

            this.$router.replace({
                path,
                query: this.$route.query,
            });
        },
        actualizarQueryExclusivos(){
            const query = { ...this.$route.query };

            if(this.mostrarExclusivos){
                query.exclusivos = "true";
            } else {
                delete query.exclusivos;
            }

            this.$router.replace({
                path: this.$route.path,
                query,
                hash: this.$route.hash,
            });
        },
        actualizarQueryBusqueda(){
            const query = { ...this.$route.query };
            const busqueda = this.busqueda.trim();

            delete query.q;

            if(busqueda){
                query.buscar = busqueda;
            } else {
                delete query.buscar;
            }

            if(query.buscar === this.$route.query.buscar && !this.$route.query.q){
                return;
            }

            this.$router.replace({
                path: this.$route.path,
                query,
                hash: this.$route.hash,
            });
        },
        normalizarTexto(texto = ""){
            return texto
                .toString()
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
        },
        ordenarPops(pops){
            pops = [...pops];

            if(this.orden === "alfabetico" || this.orden === ""){
                return pops.sort(function(a, b){          
                    if(a.nombre < b.nombre) { return -1; }
                    if(a.nombre > b.nombre) { return 1; }
                    return 0;
                })
            }

            if(this.orden === "menorPrecio"){
                return pops.sort(function(a, b){          
                    if(a.precioPublico - a.descuentoPrecioPublico < b.precioPublico - b.descuentoPrecioPublico) { return -1; }
                    if(a.precioPublico - a.descuentoPrecioPublico > b.precioPublico - b.descuentoPrecioPublico) { return 1; }
                    return 0;
                })
            } 

            if(this.orden === "mayorPrecio"){
                return pops.sort(function(a, b){          
                    if(a.precioPublico - a.descuentoPrecioPublico > b.precioPublico - b.descuentoPrecioPublico) { return -1; }
                    if(a.precioPublico - a.descuentoPrecioPublico < b.precioPublico - b.descuentoPrecioPublico) { return 1; }
                    return 0;
                })
            }
            
            if(this.orden === "masNuevo"){
                
                return pops.sort((a,b)=>{
                    let diaA = 0, diaB = 0;
                    let calcularDias = a => {
                        let ahora = moment(moment.utc()); 
                        return ahora.diff(a.fechaLlegada, "days", true);
                    };

                    diaA = !a.hasOwnProperty('fechaLlegada') ? 9999 : calcularDias(a);
                    diaB = !b.hasOwnProperty('fechaLlegada') ? 9999 : calcularDias(b);
                    
                    if(diaA < diaB){return -1}
                    if(diaA > diaB){return 1}
                    return 0;
                });
            }

            return pops;
        },
        async obtenerDatos() {
            const db = getDatabase();
            const dbRef = ref(db, "inventario");
            const snapshot = await get( dbRef);
            let pops = JSON.parse(JSON.stringify(snapshot));
            return Object.keys(pops).map((key) => {
                const pop = pops[key];

                return {
                    ...pop,
                    llavePop: key,
                    textoBusqueda: this.normalizarTexto([
                        pop.nombre,
                        pop.licencia,
                        pop.tipoPop
                    ].join(" ")),
                    tipoPopNormalizado: this.normalizarTexto(pop.tipoPop).trim(),
                };
            });
        },
        paginaActualizada(paginaActual){
            this.paginaActual = paginaActual;
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
        validacionCookieExistencias(){
            function getCookie(username) {
                let nombre = username + "=";
                let split = document.cookie.split(';');
                for(var j = 0; j < split.length; j++) {
                    let char = split[j];
                    while (char.charAt(0) == ' ') {
                    char = char.substring(1);
                    }
                    if (char.indexOf(nombre) == 0) {
                    return char.substring(nombre.length, char.length);
                    }
                }
                return "";
            }

            function checkCookie() {
                let cookie = getCookie("gladysInventario");
                if(cookie == 1) return true;
                return false;
            }

            return checkCookie();
            //let existencia = getCookie
        },
        actualizarSeleccion({ llavePop, seleccionado }){
            if(!seleccionado){
                const { [llavePop]: eliminado, ...resto } = this.figurasSeleccionadas;
                this.figurasSeleccionadas = resto;
                return;
            }

            this.figurasSeleccionadas = {
                ...this.figurasSeleccionadas,
                [llavePop]: {
                    usarDetalle: null,
                },
            };
        },
        abrirModalDetalle({ pop }){
            this.popDetallePendiente = pop;
            const opcionesSeleccion = this.opcionesParaSeleccion(pop);
            this.detalleSeleccionModal = opcionesSeleccion[0] ? opcionesSeleccion[0].id : null;
            const cantidadDisponible = validacionDisponibilidad(pop)[0];
            const tieneDetalle = this.tieneDetalleHabilitado(pop);
            const tienePrecioDetalle = this.obtenerOpcionesDetalle(pop).length > 0;

            if(cantidadDisponible === 1 && tieneDetalle && tienePrecioDetalle){
                this.detalleUnicoModalAbierto = true;
                return;
            }

            this.detalleModalAbierto = true;
        },
        mostrarPrecioDetalleEnTarjeta(pop){
            const cantidadDisponible = validacionDisponibilidad(pop)[0];
            const tieneDetalle = this.tieneDetalleHabilitado(pop);
            const tienePrecioDetalle = this.obtenerOpcionesDetalle(pop).length > 0;

            return tieneDetalle && tienePrecioDetalle && cantidadDisponible === 1;
        },
        cerrarModalDetalle(){
            this.detalleModalAbierto = false;
            this.popDetallePendiente = null;
            this.detalleSeleccionModal = null;
        },
        cerrarModalDetalleUnico(){
            this.detalleUnicoModalAbierto = false;
            this.popDetallePendiente = null;
            this.detalleSeleccionModal = null;
        },
        confirmarDetalle(){
            if(!this.popDetallePendiente){
                return;
            }

            const opcionSeleccionada = this.obtenerOpcionSeleccionada(
                this.popDetallePendiente,
                this.detalleSeleccionModal
            );

            if(!opcionSeleccionada){
                return;
            }

            this.figurasSeleccionadas = {
                ...this.figurasSeleccionadas,
                [this.popDetallePendiente.llavePop]: {
                    usarDetalle: opcionSeleccionada.tipo === "detalle",
                    detalleSeleccionado: opcionSeleccionada,
                },
            };

            this.cerrarModalDetalle();
        },
        confirmarDetalleUnico(){
            if(!this.popDetallePendiente){
                return;
            }

            this.figurasSeleccionadas = {
                ...this.figurasSeleccionadas,
                [this.popDetallePendiente.llavePop]: {
                    usarDetalle: true,
                    detalleSeleccionado: this.obtenerOpcionesDetalle(this.popDetallePendiente)[0],
                },
            };

            this.cerrarModalDetalleUnico();
        },
        limpiarSeleccion(){
            this.figurasSeleccionadas = {};
        },
        limpiarNombreParaWhatsApp(nombre){
            return nombre.replace(/\s*\(R\d+\)\s*/gi, " ").trim();
        },
        obtenerPrecioPublicoConDescuento(pop){
            const precioPublico = Number(pop.precioPublico) || 0;
            const descuento = Number(pop.descuentoPrecioPublico) || 0;
            const precioFinal = precioPublico - descuento;

            return descuento > 0 ? precioFinal : precioPublico;
        },
        tieneDetalleHabilitado(pop){
            return pop.habilitadoDetalle === true || pop["habilitado detalle"] === true;
        },
        obtenerOpcionBuenEstado(pop){
            return {
                id: "buen-estado",
                tipo: "normal",
                titulo: "Figura en buen estado",
                descripcion: "",
                precio: this.obtenerPrecioPublicoConDescuento(pop),
                precioOriginal: Number(pop.descuentoPrecioPublico) > 0 ? pop.precioPublico : null,
            };
        },
        cantidadDisponibleBuenEstado(pop){
            const cantidadDisponible = validacionDisponibilidad(pop)[0];
            const cantidadConDetalle = this.obtenerOpcionesDetalleBase(pop).length;

            return Math.max(cantidadDisponible - cantidadConDetalle, 0);
        },
        modeloSinFigurasBuenEstado(pop){
            if(!pop){
                return false;
            }

            const cantidadDisponible = validacionDisponibilidad(pop)[0];

            return cantidadDisponible > 1
                && this.obtenerOpcionesDetalleBase(pop).length >= cantidadDisponible
                && this.cantidadDisponibleBuenEstado(pop) === 0;
        },
        obtenerOpcionesDetalleBase(pop){
            if(!pop){
                return [];
            }

            const listasPosibles = [
                pop.opcionesDetalle,
                pop["opciones detalle"],
                pop.preciosDetalle,
                pop["precios detalle"],
                pop.figurasDetalle,
                pop["figuras detalle"],
                pop.figurasConDetalle,
                pop["figuras con detalle"],
                pop.detalles,
                pop.detalle,
            ];
            const listaDetalle = listasPosibles.find(lista => {
                if(Array.isArray(lista)){
                    return lista.length > 0;
                }

                return lista && typeof lista === "object" && Object.keys(lista).length > 0;
            });
            const detalles = listaDetalle
                ? (Array.isArray(listaDetalle) ? listaDetalle : Object.keys(listaDetalle).map(key => ({
                    ...listaDetalle[key],
                    llaveDetalle: key,
                })))
                : [];
            const opciones = detalles.map((detalle, index) => this.normalizarOpcionDetalle(detalle, pop, index))
                .filter(opcion => opcion.precio !== null && opcion.precio !== undefined && opcion.precio !== "");

            if(opciones.length > 0){
                return opciones;
            }

            if(pop.precioDetalle !== null && pop.precioDetalle !== undefined && pop.precioDetalle !== ""){
                return [
                    this.normalizarOpcionDetalle({
                        precioDetalle: pop.precioDetalle,
                        descripcion: pop.descripcionDetalle || pop.detalleDescripcion || "",
                    }, pop, 0),
                ];
            }

            return [];
        },
        obtenerOpcionesDetalle(pop){
            const opciones = this.obtenerOpcionesDetalleBase(pop);
            const preciosVistos = new Set();

            return opciones.filter(opcion => {
                const precioKey = String(Number(opcion.precio) || opcion.precio).trim();

                if(preciosVistos.has(precioKey)){
                    return false;
                }

                preciosVistos.add(precioKey);
                return true;
            });
        },
        normalizarOpcionDetalle(detalle, pop, index){
            const idBase = detalle.llaveDetalle || detalle.id || detalle.llave || detalle.numeroFigura || index;
            const precio = detalle.precioDetalle !== undefined ? detalle.precioDetalle : detalle.precio;
            const descripcion = detalle.descripcion || detalle.detalle || detalle.observaciones || detalle.notas || "";
            const numeroFigura = detalle.numeroFigura ? ` ${detalle.numeroFigura}` : ` ${index + 1}`;
            const titulo = detalle.titulo || detalle.nombre || `Figura con detalle/daño en caja${numeroFigura}`;

            return {
                id: `detalle-${idBase}`,
                tipo: "detalle",
                titulo,
                descripcion,
                precio,
                precioOriginal: detalle.precioOriginal || pop.precioPublico,
            };
        },
        obtenerOpcionSeleccionada(pop, idOpcion){
            return this.opcionesParaSeleccion(pop).find(opcion => opcion.id === idOpcion);
        },
        opcionesParaSeleccion(pop){
            if(!pop){
                return [];
            }

            const opcionesDetalle = this.obtenerOpcionesDetalle(pop);
            const opciones = [...opcionesDetalle];

            if(this.cantidadDisponibleBuenEstado(pop) > 0){
                opciones.unshift(this.obtenerOpcionBuenEstado(pop));
            }

            return opciones;
        },
        obtenerDetalleSeleccionado(pop, seleccion){
            if(seleccion && seleccion.detalleSeleccionado){
                return seleccion.detalleSeleccionado;
            }

            return this.obtenerOpcionesDetalle(pop)[0] || null;
        },
        obtenerPopsSeleccionados(){
            return this.datosPopOriginal.filter(
                pop => this.figurasSeleccionadas[pop.llavePop]
            );
        },
        seleccionActivaPromocionTresPorDoscientos(){
            return this.obtenerPopsSeleccionados()
                .filter(pop => this.popTienePromocionTresPorDoscientos(pop))
                .length >= 3;
        },
        popTienePromocionTresPorDoscientos(pop){
            return this.valorPromocionActivo(pop.promocionTresPorDoscientos);
        },
        obtenerPrecioSeleccion(pop, seleccion){
            const promocionActiva = this.seleccionActivaPromocionTresPorDoscientos()
                && this.popTienePromocionTresPorDoscientos(pop);
            const usaDetalle = seleccion && seleccion.usarDetalle === true;
            const detalleSeleccionado = usaDetalle ? this.obtenerDetalleSeleccionado(pop, seleccion) : null;
            const precioBase = detalleSeleccionado
                ? Number(detalleSeleccionado.precio) || 0
                : this.obtenerPrecioPublicoConDescuento(pop);

            if(promocionActiva){
                return Math.min(precioBase, 200);
            }

            return precioBase;
        },
        obtenerTextoPrecioSeleccion(pop, seleccion){
            const promocionActiva = this.seleccionActivaPromocionTresPorDoscientos()
                && this.popTienePromocionTresPorDoscientos(pop);
            const usaDetalle = seleccion && seleccion.usarDetalle === true;
            const precioPublicoConDescuento = this.obtenerPrecioPublicoConDescuento(pop);
            const detalleSeleccionado = usaDetalle ? this.obtenerDetalleSeleccionado(pop, seleccion) : null;

            if(promocionActiva){
                const precioOriginal = detalleSeleccionado
                    ? detalleSeleccionado.precio
                    : precioPublicoConDescuento;
                const precioPromocion = Math.min(Number(precioOriginal) || 0, 200);

                if(precioPromocion < 200){
                    return `Precio: $${precioPromocion}`;
                }

                return `Precio promoción: ~$${precioOriginal}~ $200`;
            }

            return detalleSeleccionado
                ? `Precio: ~$${precioPublicoConDescuento}~ $${detalleSeleccionado.precio}`
                : `Precio: $${precioPublicoConDescuento}`;
        },
        mandarWhatsApp(){
            const popsSeleccionados = this.obtenerPopsSeleccionados();
            const mensaje = [
                "Hola, me interesan estas figuras:",
                ...popsSeleccionados.map((pop, index) => {
                    const seleccion = this.figurasSeleccionadas[pop.llavePop];
                    const usaDetalle = seleccion && seleccion.usarDetalle === true;
                    const detalleSeleccionado = usaDetalle ? this.obtenerDetalleSeleccionado(pop, seleccion) : null;
                    const nombre = detalleSeleccionado
                        ? `${this.limpiarNombreParaWhatsApp(pop.nombre)} (${detalleSeleccionado.titulo})`
                        : this.limpiarNombreParaWhatsApp(pop.nombre);
                    const precioTexto = this.obtenerTextoPrecioSeleccion(pop, seleccion);
                    const detalleTexto = detalleSeleccionado && detalleSeleccionado.descripcion
                        ? [`Detalle: ${detalleSeleccionado.descripcion}`]
                        : [];

                    return [
                        `Figura ${index + 1}`,
                        `Nombre: ${nombre}`,
                        `Numero de pop: ${pop.numeroPop}`,
                        ...detalleTexto,
                        precioTexto,
                    ].join("\n");
                }),
                `Total: $${this.totalSeleccion}`
            ].join("\n\n");
            const url = `https://wa.me/524431104022?text=${encodeURIComponent(mensaje)}`;

            window.open(url, "_blank");
        }
    },
    computed: {
        datosPaginados(){
            const paginacionInicial = (this.paginaActual * this.elementosPorPagina) - this.elementosPorPagina;
            const paginacionFinal = this.paginaActual * this.elementosPorPagina;

            return this.datosPop.slice(paginacionInicial, paginacionFinal);
        },
        cantidadFigurasSeleccionadas(){
            return Object.keys(this.figurasSeleccionadas).length;
        },
        totalSeleccion(){
            if(!this.datosPopOriginal){
                return 0;
            }

            return this.datosPopOriginal.reduce((total, pop) => {
                const seleccion = this.figurasSeleccionadas[pop.llavePop];

                if(!seleccion){
                    return total;
                }

                const precio = this.obtenerPrecioSeleccion(pop, seleccion);

                return total + precio;
            }, 0);
        },
        opcionesDetalleModal(){
            return this.opcionesParaSeleccion(this.popDetallePendiente);
        },
        hayOpcionesDetalleModal(){
            return this.opcionesDetalleModal.some(opcion => opcion.tipo === "detalle");
        },
        opcionDetalleUnico(){
            return this.popDetallePendiente ? this.obtenerOpcionesDetalle(this.popDetallePendiente)[0] : null;
        },
    },
    watch: {
        "$route.hash"(){
            const orden = this.obtenerOrdenDesdeHash();

            if(orden !== this.orden){
                this.orden = orden;
                if(this.datosPopOriginal){
                    this.aplicarFiltros();
                }
            }
        },
        "$route.params.filter"(){
            const orden = this.obtenerOrdenDesdeHash();

            if(orden !== this.orden){
                this.orden = orden;
                if(this.datosPopOriginal){
                    this.aplicarFiltros();
                }
            }
        },
        "$route.query.buscar"(){
            const busqueda = this.obtenerBusquedaDesdeQuery();

            if(busqueda !== this.busqueda){
                this.busqueda = busqueda;
                if(this.datosPopOriginal){
                    this.aplicarFiltros();
                }
            }
        },
        "$route.query.q"(){
            const busqueda = this.obtenerBusquedaDesdeQuery();

            if(busqueda !== this.busqueda){
                this.busqueda = busqueda;
                if(this.datosPopOriginal){
                    this.aplicarFiltros();
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">

    @function pxToRem($value) {
        $remValue: ($value / 16) + rem; 
        @return $remValue;
    }

    .catalogo-title{
        flex: 0 0 auto;
    }

    h1{
        color: #0b94cf;
        font-weight: 500;
        margin: 0;
    }

    .catalogo-descripcion{
        margin-bottom: 1rem;
        width: 100%;
    }

    .catalogo-page{
        color: #ffffff;
        padding-bottom: pxToRem(16);
        position: relative;
    }

    .catalogo-page.con-ayuda-seleccion{
        padding-bottom: pxToRem(96);
    }

    .catalogo-header{
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: pxToRem(10) pxToRem(16);
        margin: pxToRem(12) 0;
    }

    .catalogo-page.con-acciones{
        padding-bottom: pxToRem(124);
    }

    @media (min-width: 767px){
        .catalogo-page.con-acciones{
            padding-bottom: pxToRem(104);
        }
        .catalogo-header{
            margin: pxToRem(32) 0;
        }
    }

    .all-figures-pop{
        display: grid;
        //grid-template-columns: repeat(auto-fill, 160px);
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        gap: pxToRem(15) pxToRem(10);
        justify-content: space-between;
        @media (min-width: 767px){
            grid-template-columns: repeat(auto-fill, 232px);
            gap: pxToRem(30);
            justify-content: space-between;
        }
    }

    form{
        flex: 1 1 560px;
        min-width: min(100%, 280px);
        width: auto;
        display: flex;
        flex-direction: column;
        gap: pxToRem(6);
        justify-content: flex-end;
        margin-bottom: 0;
        .busqueda{
            max-width: 100%;
            order: 1;
        }
        .form-check{
            align-items: center;
            display: flex;
            gap: pxToRem(6);
            margin-bottom: 0;
            padding-left: 0;
            white-space: nowrap;
            .form-check-input{
                float: none;
                margin-left: 0;
                margin-top: 0;
            }
            .form-check-label{
                color: #ffffff;
                line-height: 1;
            }
        }
        .limpiar-busqueda{
            background: #ffd84d;
            border-color: #ffd84d;
            color: #111;
            font-weight: 500;
            order: 2;
            white-space: nowrap;
            &:hover,
            &:focus{
                background: #ffcb05;
                border-color: #ffcb05;
                color: #111;
            }
        }
        .orden-exclusivos{
            display: flex;
            flex-direction: column;
            gap: pxToRem(10);
            order: 3;
            width: 100%;
            .orden{
                width: 100%;
            }
        }
        @media (min-width: 767px){
            align-items: flex-start;
            flex-direction: row;
            gap: pxToRem(12);
            .busqueda{
                max-width: 500px;
                order: 1;
            }
            .form-check{
                min-height: auto;
            }
            .limpiar-busqueda{
                order: 2;
            }
            .orden-exclusivos{
                align-items: center;
                flex-direction: row;
                gap: pxToRem(12);
                order: 3;
                width: auto;
                .orden{
                    width: 200px;
                }
            }
        }
        input{
            max-width: 500px;
        }
        button{
            white-space: nowrap;
        }
    }

    .sin-resultados{
        background: #fff;
        border-radius: 0.5rem;
        box-shadow: 1px 4px 4px -1px rgba(0, 0, 0, 0.15);
        color: #555;
        font-size: pxToRem(16);
        font-weight: bold;
        margin: pxToRem(20) auto 0;
        max-width: 500px;
        padding: pxToRem(24);
        text-align: center;
    }

        .acciones-seleccion{
            background: rgba(255, 255, 255, 0.96);
            border-top: 1px solid rgba(0, 0, 0, 0.08);
        bottom: 0;
        box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.12);
        left: 0;
        padding: pxToRem(8) pxToRem(10);
        position: fixed;
        right: 0;
        text-align: center;
        z-index: 1000;
        display: flex;
        flex-wrap: wrap;
        gap: pxToRem(6);
        justify-content: center;
        button{
            align-items: center;
            display: inline-flex;
            gap: pxToRem(6);
            justify-content: center;
            font-weight: bold;
            padding: pxToRem(6) pxToRem(9);
        }
        .enviar-seleccion{
            max-width: 420px;
            flex: 1 1 calc(50% - #{pxToRem(3)});
            font-size: pxToRem(15);
            max-width: none;
        }
        .limpiar-seleccion{
            background: #111;
            border-color: #111;
            color: #fff;
            flex: 1 1 calc(50% - #{pxToRem(3)});
            font-size: pxToRem(12);
            &:hover,
            &:focus{
                background: #000;
                border-color: #000;
                color: #fff;
            }
        }
        .limpiar-icon{
            display: flex;
            svg{
                fill: none;
                height: pxToRem(14);
                stroke: currentColor;
                stroke-linecap: round;
                stroke-linejoin: round;
                stroke-width: 2;
                width: pxToRem(14);
            }
        }
        .total-seleccion{
            align-items: center;
            background: #f5f5f5;
            border: 1px solid rgba(0, 0, 0, 0.08);
            border-radius: 0.375rem;
            display: inline-flex;
            flex: 1 1 100%;
            gap: pxToRem(6);
            justify-content: center;
            min-height: pxToRem(34);
            padding: pxToRem(5) pxToRem(9);
            span{
                color: #555;
                font-size: pxToRem(11);
                font-weight: bold;
                text-transform: uppercase;
            }
            strong{
                color: #111;
                font-size: pxToRem(14);
                line-height: 1;
            }
        }
        @media (min-width: 767px){
            gap: pxToRem(8);
            padding: pxToRem(12) pxToRem(16);
            button{
                gap: pxToRem(8);
                padding: pxToRem(6) pxToRem(12);
            }
            .enviar-seleccion{
                flex: 1 1 220px;
                max-width: 420px;
            }
            .limpiar-seleccion{
                flex: 0 0 auto;
                font-size: pxToRem(13);
            }
            .limpiar-icon{
                svg{
                    height: pxToRem(16);
                    width: pxToRem(16);
                }
            }
            .total-seleccion{
                flex: 0 0 auto;
                min-height: pxToRem(38);
                padding: pxToRem(6) pxToRem(12);
                span{
                    font-size: pxToRem(12);
                }
                strong{
                    font-size: pxToRem(16);
                }
            }
        }
            .whatsapp-icon{
                display: flex;
                svg{
                    fill: currentColor;
                    height: pxToRem(18);
                    width: pxToRem(18);
                }
            }
        }

    .detalle-modal-backdrop{
        align-items: center;
        background: rgba(0, 0, 0, 0.45);
        bottom: 0;
        display: flex;
        justify-content: center;
        left: 0;
        padding: pxToRem(10);
        position: fixed;
        right: 0;
        top: 0;
        z-index: 1100;
        @media (min-width: 767px){
            padding: pxToRem(16);
        }
    }

    .detalle-modal{
        background: #fff;
        border-radius: 0.75rem;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
        color: #111;
        max-width: 580px;
        width: 100%;
    }

    .detalle-modal-header{
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        display: flex;
        justify-content: space-between;
        padding: pxToRem(10) pxToRem(12);
        h2{
            font-size: pxToRem(16);
            font-weight: bold;
            margin: 0;
        }
        @media (min-width: 767px){
            padding: pxToRem(14) pxToRem(16);
        }
    }

    .detalle-modal-body{
        padding: pxToRem(12);
        @media (min-width: 767px){
            padding: pxToRem(16);
        }
    }

    .detalle-modal-opciones{
        display: grid;
        gap: pxToRem(8);
        grid-template-columns: 1fr;
    }

    .detalle-modal-opcion{
        align-items: flex-start;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: pxToRem(8);
        cursor: pointer;
        display: flex;
        gap: pxToRem(8);
        padding: pxToRem(10);
        &:has(.detalle-radio:checked){
            border-color: #111;
            box-shadow: 0 0 0 1px #111;
        }
        .detalle-radio{
            flex: 0 0 auto;
            margin-top: pxToRem(3);
        }
        .detalle-opcion-contenido{
            display: flex;
            flex: 1;
            flex-direction: column;
            gap: pxToRem(6);
            min-width: 0;
        }
        .detalle-opcion-titulo{
            font-size: pxToRem(14);
            line-height: 1.25;
        }
        .detalle-opcion-descripcion{
            color: #555;
            font-size: pxToRem(12);
            line-height: 1.35;
        }
        @media (min-width: 767px){
            gap: pxToRem(10);
            padding: pxToRem(14);
            .detalle-opcion-titulo{
                font-size: pxToRem(15);
            }
        }
    }

    .detalle-btn-icon{
        display: flex;
        flex: 0 0 auto;
        svg{
            fill: none;
            height: pxToRem(16);
            stroke: currentColor;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 2;
            width: pxToRem(16);
        }
    }

    .detalle-modal-texto,
    .detalle-modal-subtexto{
        font-size: pxToRem(13);
        line-height: 1.35;
        margin-bottom: pxToRem(10);
    }

    .detalle-modal-subtexto{
        span{
            display: block;
            margin-bottom: pxToRem(6);
        }
    }

    .detalle-modal-precios{
        align-items: baseline;
        display: flex;
        gap: pxToRem(8);
        flex-wrap: wrap;
        @media (min-width: 767px){
            gap: pxToRem(10);
        }
    }

    .precio-original{
        color: #888;
        font-size: pxToRem(13);
    }

    .precio-detalle{
        color: #111;
        font-size: pxToRem(15);
        @media (min-width: 767px){
            font-size: pxToRem(16);
        }
    }

    .detalle-modal-whatsapp{
        align-items: center;
        color: #198754;
        display: flex;
        font-size: pxToRem(12);
        font-weight: bold;
        gap: pxToRem(6);
        line-height: 1.25;
        margin: 0;
        @media (min-width: 767px){
            font-size: pxToRem(13);
            line-height: 1.3;
        }
    }

    .detalle-whatsapp-icon{
        display: flex;
        flex: 0 0 auto;
        svg{
            fill: currentColor;
            height: pxToRem(16);
            width: pxToRem(16);
        }
    }

    .detalle-caja-aviso{
        align-items: flex-start;
        color: #a66b00;
        display: flex;
        font-size: pxToRem(12);
        font-weight: bold;
        gap: pxToRem(6);
        line-height: 1.3;
        margin: pxToRem(6) 0 0;
        @media (min-width: 767px){
            font-size: pxToRem(13);
        }
    }

    .detalle-caja-aviso-icon{
        display: flex;
        flex: 0 0 auto;
        margin-top: pxToRem(1);
        svg{
            fill: none;
            height: pxToRem(16);
            stroke: currentColor;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 2;
            width: pxToRem(16);
        }
    }

    .detalle-modal-nota{
        font-size: pxToRem(13);
        line-height: 1.35;
        margin-bottom: pxToRem(10);
        strong{
            font-weight: bold;
        }
    }

    .detalle-modal-alerta{
        font-size: pxToRem(13);
        line-height: 1.35;
        margin-bottom: pxToRem(10);
        padding: pxToRem(8) pxToRem(10);
    }

    .detalle-modal-nota-destacada{
        color: #111;
        font-weight: bold;
        margin: 0 0 pxToRem(10);
        @media (min-width: 767px){
            margin-bottom: pxToRem(14);
        }
    }

    .detalle-modal-acciones{
        display: flex;
        gap: pxToRem(10);
        justify-content: flex-end;
        margin-top: pxToRem(12);
        .btn{
            white-space: normal;
        }
    }

</style>
